/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Section_AccessInputs */



/**
* | output |
* | --- |
* | "Access" |
*
* @param {Team_Share_Section_AccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_section_access = /** @type {((inputs?: Team_Share_Section_AccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Section_AccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Access")
	if (locale === "de") return /** @type {LocalizedString} */ ("Access")
	if (locale === "it") return /** @type {LocalizedString} */ ("Access")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Access")
	if (locale === "es") return /** @type {LocalizedString} */ ("Access")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Access")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Access")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Access")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Access")
	return /** @type {LocalizedString} */ ("Access")
});